import { render } from "./SkippersItem.vue?vue&type=template&id=059ebad4&scoped=true"
import script from "./SkippersItem.vue?vue&type=script&lang=js"
export * from "./SkippersItem.vue?vue&type=script&lang=js"

import "./SkippersItem.vue?vue&type=style&index=0&id=059ebad4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-059ebad4"

export default script